export interface APIRequest
{
    getUserId(): string;
}

export class APIRequestDtoImpl implements APIRequest
{
    getUserId(): string {
        return "1";
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/apiRequest.ts